import { render, staticRenderFns } from "./TableColumnCustomizer.vue?vue&type=template&id=046d307b&scoped=true&"
import script from "./TableColumnCustomizer.vue?vue&type=script&lang=js&"
export * from "./TableColumnCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./TableColumnCustomizer.vue?vue&type=style&index=0&id=046d307b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d307b",
  null
  
)

export default component.exports